import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { PaymentList } from '@modules/payments/Domain/payment.model';
import { GET_PAYMENTS_LIST } from '@modules/payments/Domain/Config/get_payments.config';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private apollo: Apollo) {}

  getPayments(criteria: any): Observable<PaymentList> {
    return this.apollo
      .query<{ paymentList: PaymentList }>({
        query: GET_PAYMENTS_LIST,
        variables: {
          criteria,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res.data.paymentList));
  }
}
